import { Component, OnInit } from '@angular/core';
import { MenuService } from '@app/shared/services/menu.service';
import { SessionService } from '@app/shared/services/session.service';

@Component({
  selector: 'app-submenu',
  templateUrl: './submenu.component.html',
  styleUrls: ['./submenu.component.scss']
})
export class SubmenuComponent {

  constructor(
    public menu: MenuService,
    public session: SessionService
  ) {}

  ngOnInit(): void {
    console.log(this.session)
  }

}
